<template>
  <a-modal title="忘记密码" :visible="visible" @ok="handleOk" @cancel="handleCancel" class="change-password-modal">
    <a-form-model ref="ruleForm" :model="form" :rules="rules">
      <a-form-model-item label="手机号" prop="mobile">
        <a-input v-model="form.mobile"
                 type="number"
                 ref="inputMobile"
                 autocomplete="off"
                 :maxLength="11"
                 @change="onInputMobile" />
      </a-form-model-item>
      <a-form-model-item label="验证码" prop="verifyCode">
        <a-input v-model="form.verifyCode" class="input-vcode"  />
          <div class="verification-code" :class="form.mobile.length == 11 ? 'basic-code-active' :''" @click="btnVerificationCode">{{ time>0?time+'S后重试' :'获取验证码' }}</div>
      </a-form-model-item>
      <a-form-model-item label="新密码" prop="password">
        <a-input-password v-model="form.password"  autocomplete="new-password" />
      </a-form-model-item>
      <a-form-model-item label="确认密码" prop="password">
        <a-input-password v-model="form.password1"  autocomplete="new-password" />
      </a-form-model-item>
    </a-form-model>
  </a-modal>
</template>
<script>
    import {sendCode,findPassword} from "@/utils/api";
export default {
  data () {
    return {
      visible: false,
      rules: {
          mobile: [{ required: true, message: '请输入手机号' }],
          verifyCode: [{ required: true, message: '请输入验证码'}],
          password: [{ required: true, message: '请输入密码'}],
      },
      form: {
          mobile: '',
          verifyCode:'',
          password:'',
          password1:''
      },
        timer: null,
        time: 0,
        verifyKey:'',
    }
  },
  mounted () {

  },
  methods: {
    show () {
        this.form.mobile =''
        this.form.verifyCode =''
        this.form.password =''
        this.form.password1 =''
      this.visible = true
    },
    handleOk () {
        if(this.form.password != this.form.password1){
            this.$message.warn('两次密码不一致哦~')
            return;
        }
        if(this.isEmpty(this.form.mobile) || this.isEmpty(this.form.verifyCode) || this.isEmpty(this.form.password)){
            this.$message.warn('请填入信息')
            return;
        }
        let data = new FormData()
        data.append('mobile',this.form.mobile)
        data.append('newPassword',this.$md5(this.form.password.replace(/^\s*|\s*$/g, "")))
        data.append('verifyCode',this.form.verifyCode)
        data.append('verifyKey',this.verifyKey)
        findPassword(data,{
            token:''
        }).then((res)=>{
            if(res.success){
                this.visible = false
                this.$message.success('设置成功')
            }else{
                this.$message.warn(res.logMessage)
            }
        })
    },
    handleCancel () {
      this.visible = false
    },
    resetForm () {
      this.$refs.ruleForm.resetFields();
    },
      /**
       * @description: 获取验证码（方法描述）
       */
      btnVerificationCode(){
          if(!this.timer){
              if(!this.isEmpty(this.form.mobile)){
                  let data = new FormData()
                  data.append('mobile',this.form.mobile)
                  sendCode(data,{
                      token:''
                  }).then((res)=>{
                      if(res.success){
                          this.verifyKey = res.result.key
                          this.$message.success('信息已经发到您的手机上了~')
                          this.resetTime()
                      }
                  })
              }else{
                  this.$message.warn('请输入手机号')
              }
          }else{
              this.$message.success('信息已经发到您的手机上了~')
          }
      },
      resetTime(){
          this.time = 60
          this.timer = setInterval(()=>{
              if(this.time > 0){
                  this.time--
              }else{
                  clearInterval(this.timer)
                  this.timer = null
                  this.time = 0
              }
          },1000)
      },
      onInputMobile(){
          setTimeout(()=>{
              this.form.mobile = this.$refs.inputMobile.value
              console.log(this.form.mobile)
          },20)
      },
  },
}
</script>

<style lang="scss">
    .input-vcode{
        width: 254px !important;
    }
.change-password-modal {
  width: 620px !important;
  height: 500px !important;
  .ant-modal-title {
    font-size: 18px;
  }
  .ant-modal-body {
    padding: 30px 75px 0 75px;
  }
  .ant-modal-content, .ant-modal-header {
      border-radius: 10px;
  }
  .ant-form-item {
    height: 60px;
    display: flex;
    margin-bottom: 0 !important;
    .ant-form-item-label {
      width: 86px;
      text-align: right;
    }
    .ant-form-item-control-wrapper {
      .ant-input {
        width: 360px;
        height: 36px !important;
        line-height: 34px !important;
        border-radius: 2px !important;
      }
    }
  }
  .ant-modal-footer {
    padding: 40px 0 60px 0;
    .ant-btn {
      width: 140px;
      height: 40px;
      border-radius: 6px;
    }
  }
    .basic-code-active{
        background-color: var(--co) !important;
        color: #fff !important;
    }
  .verification-code {
    display: inline-block;
    width: 100px;
    margin-left: 6px;
    background-color: #fafafa;
    height: 36px;
    line-height: 34px;
    text-align: center;
    color: #aaaaaa;
    border-radius: 2px;
    border: 1px solid #e6e6e6;
    cursor: pointer;
    outline: none;
  }
}
</style>
